<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <aside class="auth-showcase" aria-hidden="true">
      <div class="auth-showcase__inner">
        <div class="auth-showcase__mockup">
          <div class="auth-showcase__mockup-bar">
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
          </div>
          <div class="auth-showcase__mockup-body">
            <img
              src="/assets/images/logos/logo-icon.svg"
              class="auth-showcase__mockup-logo"
              alt=""
            />
            <span class="auth-showcase__mockup-chip">{{ 'auth.showcase.chip' | translate }}</span>
          </div>
        </div>

        <div class="auth-showcase__slides">
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide1Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide1Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide2Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide2Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide3Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide3Body' | translate }}</p>
          </div>
        </div>

        <div class="auth-showcase__dots" aria-hidden="true">
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
        </div>
      </div>
    </aside>

    <main class="auth-main auth-main--flow">
      <div class="auth-main__content">
        <nav class="auth-mobile-nav" [attr.aria-label]="'auth.login.back' | translate">
          <a
            class="auth-back auth-back--icon"
            routerLink="/authentication/login"
            [attr.aria-label]="'auth.login.back' | translate"
          >
            <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
          </a>
        </nav>

        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.login.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          <h1 class="auth-panel__title">{{ 'auth.forgotPassword.title' | translate }}</h1>
          <p class="auth-panel__subtitle">{{ 'auth.forgotPassword.subtitle' | translate }}</p>

          <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.forgotPassword.email' | translate }}</mat-label>
              <input
                matInput
                type="email"
                inputmode="email"
                autocomplete="email"
                formControlName="email"
              />
              @if (showFieldError(f['email'])) {
                @if (f['email'].errors?.['required']) {
                  <mat-error>{{ 'auth.forgotPassword.emailRequired' | translate }}</mat-error>
                } @else if (f['email'].errors?.['pattern']) {
                  <mat-error>{{ 'auth.forgotPassword.emailInvalid' | translate }}</mat-error>
                }
              }
            </mat-form-field>

            <button
              mat-flat-button
              color="primary"
              class="auth-btn-primary"
              type="submit"
              [disabled]="isSubmitting"
            >
              {{ 'auth.forgotPassword.submit' | translate }}
            </button>

            @if (errorMessage) {
              <p class="auth-form-error" role="alert">{{ errorMessage }}</p>
            }
          </form>
        </div>
      </div>
    </main>
  </div>
</div>
